import { useCallback, useEffect, useMemo, useState } from "react";
import Cookie from "universal-cookie";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { get_order } from "../../../../api/calls/order/get_order";
import { get_parcel_with_code } from "../../../../api/calls/parcel/get_parcel";
import { setMainModal } from "../../../../reducers/slices/main";
const cookie = new Cookie();
export function useOrderDetailsState() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const order_id = searchParams.get("orderId");
    const [orderId, setOrderId] = useState("");
    useEffect(() => {
        if (order_id) {
            setOrderId(order_id);
        }
    }, [order_id]);
    const [order, setOrder] = useState();
    const [parcel, setParcel] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const amount = useMemo(() => order?.total ?? "0", [order]);
    const history = useMemo(() => order?.status_history, [order]);
    const orderDate = useMemo(() => (order?.order_date ? dayjs(order?.order_date).format("MMM DD, YYYY, HH:mm A") : ""), [order]);
    const primaryAddress = useMemo(() => order?.addresses?.find(({ is_primary }) => !!is_primary), [order]);
    // const shippingAddress = useMemo(() => order?.addresses?.find(({ is_primary }) => !!!is_primary), [order]);
    const billingAddress = useMemo(() => order?.delivery_address, [order]);
    const shippingAddress = useMemo(() => order?.delivery_address, [order]);
    const orderUser = useMemo(() => order?.user ?? { name: "", surname: "", cell_number: "", email: "" }, [order]);
    const products = useMemo(() => order?.product_list ?? [], [order]);
    const productCount = useMemo(() => order?.product_list?.length ?? 0, [order]);
    const status = useMemo(() => order?.status ?? "", [order]);
    const parcelStatus = useMemo(() => parcel?.status ?? "", [parcel]);
    const recipient = useMemo(() => ({ full_name: `${orderUser?.name} ${orderUser?.surname}`, phone_number: orderUser?.cell_number, email: orderUser?.email }), [orderUser]);
    const onBackClicked = useCallback(() => {
        navigate(-1);
    }, []);
    useEffect(() => {
        const fetchOrder = async (id) => {
            const response = await get_order({ _id: id });
            if (response?.success) {
                const order = response?.content;
                setOrder(order);
                if (order?.check_parcel_url) {
                    const parcelResponse = await get_parcel_with_code({ code: getLastParamFromUrl(order.check_parcel_url ?? "", "track-order") ?? "" });
                    if (parcelResponse?.success) {
                        setParcel(parcelResponse?.content);
                    }
                    else {
                        dispatch(setMainModal({
                            title: "Could not retrieve Parcel details!",
                            messages: [parcelResponse?.message],
                        }));
                    }
                }
                setIsLoading(false);
            }
            else {
                setIsLoading(false);
                dispatch(setMainModal({
                    title: "Could not retrieve Order!",
                    messages: [response?.message],
                }));
            }
        };
        if (!!orderId) {
            fetchOrder(orderId);
        }
    }, [orderId]);
    const getLastParamFromUrl = (url, keyword) => {
        try {
            const parsedUrl = new URL(url);
            const fragment = parsedUrl.hash.startsWith("#") ? parsedUrl.hash.substring(1) : parsedUrl.hash;
            if (fragment.includes(keyword)) {
                const parts = fragment.split("/");
                const index = parts.indexOf(keyword);
                if (index !== -1 && index + 1 < parts.length) {
                    return parts[index + 1];
                }
            }
            return "";
        }
        catch {
            return "";
        }
    };
    return useMemo(() => ({
        amount,
        history,
        onBackClicked,
        order,
        orderDate,
        primaryAddress,
        products,
        productCount,
        recipient,
        billingAddress,
        shippingAddress,
        status,
        parcelStatus,
        isLoading,
    }), [amount, history, onBackClicked, order, orderDate, primaryAddress, products, productCount, recipient, billingAddress, shippingAddress, status, parcelStatus, isLoading]);
}
